import React from "react";
import Image from "@/bit/components/next13.components.c-image";
import Link from "@/bit/components/next13.components.custom-link";
import Text from "@/bit/components/next13.components.text";

const ImageCardBig = (props) => {
  const { isSmall } = props;
  return (
    <div
      className={`image-card ${
        isSmall ? "small aspect-ratio-7-5" : "big aspect-ratio-2-3"
      }`}
    >
      {props["Image-1"] && (
        <Image fill objectFit="cover" {...props["Image-1"]} />
      )}
      <div className="shadow" />
      <div className="card-content">
        {props["Text-1"] && <Text {...props["Text-1"]} />}
      </div>
      {props["Link-1"] && <Link {...props["Link-1"]} />}
    </div>
  );
};

export default ImageCardBig;
